var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"auth-page"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"my-5"},[_c('H1',[_vm._v("\n        Login\n      ")]),_c('auth-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }